exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-body-stats[data-v-392ad73b]{position:static;padding:0}.panel-body-stats p[data-v-392ad73b]{margin-left:0}.panel-body-stats p+p[data-v-392ad73b]{margin-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-392ad73b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/details/MaterialDetails.vue
// module id = 660
// module chunks = 1